import React, { Component } from 'react';
import { connect } from 'react-redux';
import store from '../../../store/reducers/rootReducer';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

export class GMProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }
  handle = (e, product) => {
    e.preventDefault();
    if (localStorage.getItem('cart')) {
      var setcart = JSON.parse(localStorage.getItem('cart'));
      var container = setcart.filter((item) => item.pid === product.pid);
      if (container.length === 0) {
        setcart[setcart.length] = { ...product, quantity: 1 };
        localStorage.setItem('cart', JSON.stringify(setcart));
        store.dispatch({ type: 'ADD_TO_CART', payload: { data: setcart } });
      }
    } else {
      var addtolocal = [{ ...product, quantity: 1 }];
      localStorage.setItem('cart', JSON.stringify(addtolocal));
      store.dispatch({ type: 'ADD_TO_CART', payload: { data: addtolocal } });
    }
  };

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  render() {
    const added = localStorage.getItem('cart')
      ? JSON.parse(localStorage.getItem('cart')).filter(
          (item) => item.pid === this.props.pid
        )
      : [];
    var desc = this.props.description[0];
    var ellipsis = '...';
    // var brt = true;
    // if (desc.length > 39) {
    //   brt = false;
    // }
    if (desc.length > 61) {
      desc = desc.slice(0, 61);
      desc = desc.concat(ellipsis);
      // brt = true;
    }
    var name = this.props.name;
    var ellipsis2 = '..';
    // var brt2 = true;
    // if (name.length > 16) {
    //   brt2 = false;
    // }
    if (name.length > 20) {
      name = name.slice(0, 20);
      name = name.concat(ellipsis2);
      // brt = true;
    }
    return (
      <div className="col-12" style={{ padding: '0px', margin: '0px' }}>
        {/* Modal */}
        <Modal isOpen={this.state.isOpen} size="lg" toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Product Details</ModalHeader>
          <ModalBody>
            <div className="container-fluid">
              <div className="row">
                <div className="col-6" style={{ maxHeight: '15em' }}>
                  <img
                    src={this.props.image}
                    alt="product details"
                    style={{ width: '100%', height: '200px' }}
                  />
                </div>
                <div className="col-6">
                  <div className="row">
                    <div className="col-12">
                      <h2 style={{ textTransform: 'capitalize' }}>
                        {' '}
                        {this.props.name}{' '}
                      </h2>
                    </div>
                    <div className="col-12">
                      <h4> ${this.props.price} </h4>
                    </div>
                    <div className="col-12" style={{ wordWrap: 'break-word' }}>
                      <h6> {this.props.description} </h6>
                    </div>
                    <div className="col-12">
                      {this.props.stock[0] || this.props.stock > 0 ? (
                        <button
                          className="btn btnAdd"
                          onClick={(event) =>
                            this.handle(event, this.props.product)
                          }
                        >
                          {' '}
                          {added.length === 0 ? (
                            <i className="fa fa-plus"> Add</i>
                          ) : (
                            'Added'
                          )}
                        </button>
                      ) : (
                        <button className="btn btnAdd"> Out of stock</button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        {/* Modal end */}
        <div
          className="card text-left grocery-card"
          onClick={this.toggle}
          style={{
            border: '0.1em solid #fff',
            boxShadow:
              '0 10px 35px rgba(50,50,93,.1),0 2px 15px rgba(0,0,0,.07)',
            marginBottom: '10px'
          }}
        >
          {this.props.product.price[0] < this.props.product.mrp[0] ? (
            <span
              class="badge badge-success"
              style={{ width: '20%', position: 'absolute' }}
            >
              On Sale
            </span>
          ) : null}
          <img
            className="card-img-top"
            src={this.props.image}
            style={{ height: '13rem' }}
            alt="Card cap"
          />
          <div className="card-body">
            <h5
              className="card-title"
              style={{ textTransform: 'capitalize', fontWeight: '600' }}
            >
              {' '}
              {this.props.name}{' '}
            </h5>
            <p
              className="card-text grocery-card-description"
              style={{
                textTransform: 'capitalize',
                fontWeight: '300',
                color: '#00000090'
              }}
            >
              {' '}
              {desc}{' '}
            </p>
          </div>
          <div className="card-footer" style={{ background: '#ffffff90' }}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-6 pl-0">
                  <div class="price">{this.props.price}</div>
                </div>
                <div className="col-6 pr-0" style={{ textAlign: 'end' }}>
                  {this.props.stock[0] || this.props.stock > 0 ? (
                    <button
                      className="btn btnAdd"
                      style={{
                        border: '1px solid #00000020',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        color: '#000000',
                        borderRadius: '50px',
                        cursor: 'pointer'
                      }}
                      onClick={(event) =>
                        this.handle(event, this.props.product)
                      }
                    >
                      <i className="fa fa-plus">&nbsp;Add</i>
                    </button>
                  ) : (
                    <button
                      style={{
                        border: '1px solid #a8e4d5',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        color: '#a8e4d5',
                        borderRadius: '50px',
                        cursor: 'pointer'
                      }}
                      className="btn disabled"
                    >
                      Out of Stock
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateWithProps = (state) => ({
  vendors: state.user.vendors,
  subCategories: state.user.subCategories,
  products: state.user,
  vendor: state.shared.vendor,
  auth: state.user.auth,
  loader: state.ui.user_loading
});

export default connect(mapStateWithProps, null)(GMProducts);
